import {
  Anchor,
  Breadcrumbs,
  Group,
  Stack,
  Text,
} from '@mantine/core'
import IonIcon from '@reacticons/ionicons'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { DealParams } from 'app/models/deal-params'
import { useDispatch, useSelector } from 'react-redux'
import { loadAllFacilities } from 'app/state/ducks/facilities/thunks'
import { getDeal, getDeals } from 'app/state/ducks/deals/selectors'
import { loadEntities } from 'app/state/ducks/entities/thunks'
import { getDealAmendments } from 'app/state/ducks/deal-amendments/selectors'
import { loadAllDealAmendments } from 'app/state/ducks/deal-amendments/thunks'
import { loadAllDeals, setOneDeal } from 'app/state/ducks/deals/thunks'
import DealHeader from '../deals/deal-details/deal-header'
import { formatNumberToCurrency, getLabelByValue } from 'app/utils/util-functions'
import { frequencyOptions } from 'app/models/dropdown-options'
import { NewTextInput } from 'app/views/components/inputs/NewTextInput'
import SegmentControlUpdated from 'app/views/components/segments/segment-control-updated'


export default function DealFeesContentPage(): JSX.Element {
  const navigate = useNavigate()
  const { dealId, status, feeType } = useParams()

  const dispatch = useDispatch()
  const deal: DealParams | undefined = useSelector(getDeal)
  const allDeals: DealParams[] = useSelector(getDeals)
  const dealAmendments: DealParams[] = useSelector(getDealAmendments)
  const fee = deal?.fees.find(fee => fee.feeType === feeType)

  const tabs: { [key: string]: { route: string; label: string; active: boolean; pageRender: JSX.Element; } } = {};
  deal?.fees.forEach(fee => {
    const route = `/dealmanagement/deal/${dealId}/${status}/fees/${fee.feeType}`
    tabs[fee.feeType + 'Fee'] = {
      route,
      label: fee.feeType.replace(/([a-z])([A-Z])/g, '$1 $2').toUpperCase(),
      active: fee.feeType === feeType, // Set active based on feeType
      pageRender: <DealFeesContentPage />,
    }
  })

  useEffect(() => {
    if (allDeals) {
      const selectedDeal = allDeals.find(deal => deal.id === dealId)
      if (selectedDeal) {
        selectedDeal.amendment = false
        dispatch(setOneDeal(selectedDeal))
      }
    }
    if (dealAmendments) {
      const amended_deal = dealAmendments.find(
        amendment => amendment.id === dealId
      )
      if (amended_deal) {
        amended_deal.amendment = true
        dispatch(setOneDeal(amended_deal))
      }
    }
  }, [allDeals, dealId, dealAmendments])

  useEffect(() => {
    dispatch(loadAllDeals())
    dispatch(loadEntities())
  }, [dealId])

  useEffect(() => {
    dispatch(loadAllFacilities())
    dispatch(loadAllDealAmendments())
  }, [])

  const items = [
    { title: 'Deal Management', href: '/dealmanagement' },
    { title: deal?.dealName ?? 'Deal', href: `/dealmanagement/deal/${deal?.id}/${status}` }
  ].map((item, index) => (
    <Anchor
      onClick={() => navigate(item.href)}
      key={'deal-page-breadcrum' + index}
      color="#374151"
      fw={500}
      fz="14px"
    >
      {item.title}
    </Anchor>
  ))

  return (
    <Stack w="100%">
      <Breadcrumbs
        separator={<IonIcon name="chevron-forward-outline" />}
        mt="xs"
      >
        {items}
      </Breadcrumbs>
      {deal ? <DealHeader deal={deal} customTitle='Fees' showStatusPill={false} /> : null}
      <Group w="100%" position="apart" className='tabsGapsActivity'>
        <Group position="right">
          <SegmentControlUpdated tabs={tabs} />
        </Group>
      </Group>

      <Text className='sectionDetailHeader'>Fee Details</Text>
      <Group noWrap w="100%" mt='12px' mb='12px'>
        <Group className='feeDetailGroup' w="19%" noWrap>
          <NewTextInput className='feeDetailInput' readOnly label='Fee Type' placeholder='Fee Type' value={fee?.feeType.replace(/([a-z])([A-Z])/g, '$1 $2')} />
        </Group>
        <Group className='feeDetailGroup' w="19%" noWrap>
          <NewTextInput className='feeDetailInput' readOnly label='Fee Rate' placeholder='Fee Rate' value={fee?.feeRate} />
        </Group>
        <Group className='feeDetailGroup' w="18%" noWrap>
          <NewTextInput className='feeDetailInput' readOnly label='Fee Rate' placeholder='Fee Rate' value={formatNumberToCurrency((Number(fee?.feeRate) / 100) * Number(deal?.amount), deal?.currency ?? 'USD')} />
        </Group>
        <Group className='feeDetailGroup' w="25%" noWrap>
          <NewTextInput className='feeDetailInput' readOnly label='Payment Date' placeholder='Payment Date' value={fee?.firstPaymentDate} />
        </Group>
        <Group className='feeDetailGroup' w="19%" noWrap>
          <NewTextInput className='feeDetailInput' readOnly label='Frequency' placeholder='Frequency' value={getLabelByValue(fee?.frequency ?? '', frequencyOptions)} />
        </Group>
      </Group>

    </Stack>
  )
}
